import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { hasIn } from 'lodash';
import { CustomValidators } from 'ng2-validation';
import { Observable } from 'rxjs';
import { acceptInvitation } from 'src/app/core/store/account/account.actions';
import { AccountState, isAuthenticating } from 'src/app/core/store';

import {
  AcceptInvitationParams,
  AccountsService,
  Unsubscribe,
} from '../../core';
import { NotificationService } from '../../core/services/notification.service';

@Component({
  selector: 'app-invite',
  templateUrl: './invite.component.html',
  styleUrls: ['./invite.component.less'],
})
export class InviteComponent extends Unsubscribe implements OnInit {
  inviteForm: FormGroup;
  isSubmitting$: Observable<boolean>;
  passwordVisible = false;
  confirmPasswordVisible = false;
  password: FormControl;
  confirmPassword: FormControl;

  constructor(
    private notificationService: NotificationService,
    private fb: FormBuilder,
    private accountsService: AccountsService,
    private router: Router,
    private route: ActivatedRoute,
    private store: Store<AccountState>
  ) {
    super();

    this.password = new FormControl('', [
      Validators.maxLength(40),
      Validators.required,
      Validators.minLength(8),
      Validators.pattern(
        '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,40}$'
      ),
    ]);
    this.confirmPassword = new FormControl('', [
      CustomValidators.equalTo(this.password),
    ]);

    this.inviteForm = this.fb.group(this.inviteFormModel());
  }

  ngOnInit(): void {
    this.parseParams();
    this.isSubmitting$ = this.store.select(isAuthenticating);
  }

  parseParams() {
    if (hasIn(this.route.snapshot.queryParams, 'code')) {
      const code = this.route.snapshot.queryParams['code'];
      this.inviteForm.get('invitationCode').setValue(code);
    } else {
      // handle no code
      this.notificationService.error('MESSAGE.SUCCESS', 'PAGE.INVITE.NO_CODE');
    }

    if (hasIn(this.route.snapshot.queryParams, 'email')) {
      const email = this.route.snapshot.queryParams['email'];
      this.inviteForm.get('email').setValue(email);
    }

    if (hasIn(this.route.snapshot.queryParams, 'firstname')) {
      const firstname = this.route.snapshot.queryParams['firstname'];
      this.inviteForm.get('firstname').setValue(firstname);
    }

    if (hasIn(this.route.snapshot.queryParams, 'lastname')) {
      const lastname = this.route.snapshot.queryParams['lastname'];
      this.inviteForm.get('lastname').setValue(lastname);
    }
  }

  inviteFormModel(): any {
    return {
      email: [
        '',
        [Validators.required, Validators.maxLength(40), CustomValidators.email],
      ],
      password: this.password,
      invitationCode: ['', [Validators.required]],
      confirmPassword: this.confirmPassword,
      firstname: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
    };
  }

  submitForm(): void {
    const acceptInvitationParams: AcceptInvitationParams = {
      email: this.inviteForm.get('email').value,
      password: this.inviteForm.get('password').value,
      invitationCode: this.inviteForm.get('invitationCode').value,
      firstname: this.inviteForm.get('firstname').value,
      lastname: this.inviteForm.get('lastname').value,
    };

    this.store.dispatch(acceptInvitation({ params: acceptInvitationParams }));
  }
}
